// ProductDetails.jsx
import React from "react";
import { useParams, Link } from "react-router-dom";
import { products } from "./ProductsWeDeal";
import "./ProductDetails.css";

export default function ProductDetails() {
  const { id } = useParams();
  const product = products.find((p) => p.id === parseInt(id));

  if (!product) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Product Not Found</h2>
        <Link to="/">Go Back</Link>
      </div>
    );
  }

  return (
    <div className="product-details">
  <img src={product.img} alt={product.title} className="product-image" />
  <div className="product-info">
    <h1>{product.title}</h1>

    {/* Description */}
    {typeof product.desc === "string" ? (
      <p>{product.desc}</p>
    ) : (
      product.desc
    )}

    {/* List (if available) */}
    {product.list && (
      <ul>
        {product.list.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    )}

    <Link to="/" className="back-btn">
      ← Back to Products
    </Link>
  </div>
</div>

  );
}
